import React from "react";
import { FormattedMessage } from "react-intl";
import { ArrowLongLeftIcon } from "@heroicons/react/20/solid";

import * as styles from "./styles.scss";
import { IconButton } from "../IconButton";

export const BackButton = ( props ) => {
	const goBack = () => {
		window.history.back();
	};

	return (
		<IconButton
			type="button"
			variant="secondary"
			onClick={ goBack }
		>
			<ArrowLongLeftIcon className={ styles.icon } />
			<FormattedMessage id="button.back" defaultMessage="Go back" />
		</IconButton>
	);
};
